<template>
  <div class="volumes_card">
    <div class="volumes_content">
      <div :style="{background: chartColors[volumeKey]}" class="icon-background">
        <svg-icon :name="icon" class="icon-volume" :size="'large'" />
      </div>
      <div class="volume_info">
        <span class="volume_label" :title="itCouldBeTruncated">
          {{ label }}
        </span>
        <spinner
          v-if="loading && !error"
          width="20"
          height="20"
        />
        <div v-else-if="!loading && error" class="svg_icon_position">
          <svg-icon name="reload" size="medium" />
        </div>
        <span v-else class="volume_count">
          {{ counter }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { VOLUME_CHART_COLORS } from '@/utils/constants'

export default {
    name: 'VolumesCard',
    props: {
        label: {
            type: String,
            default: ''
        },

        counter: {
            type: [String, Number],
            default: '0',
        },

        icon: {
            type: String,
            default: ''
        },

        volumeKey: {
            type: String,
            default: ''
        },

        loading: {
            type: Boolean,
            default: false
        },

        error: {
            type: Boolean,
            default: false
        },

        truncable: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            chartColors: VOLUME_CHART_COLORS,
        }
    },

    
    computed: {
        itCouldBeTruncated() {
            if (this.truncable) return this.label
            return false  
        }
    }
}
</script>

<style lang="scss" scoped>
.volumes_card {
  display: flex;
  max-width: 608px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 16px 18px;

  .volumes_content {
    display: flex;
    align-items: center;
    width: 100%;
  }

  .volume_info {
    display: flex;
    flex-direction: column;
    margin-left: 12px;
    flex: 1;
    min-width: 0;
    .svg_icon_position {
      display: flex;
      margin-left: 0;
    }
  }

  .volume_label {
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 100%;
  }

  .volume_count {
    font-size: 17px;
    color: #111727;
    font-weight: normal;
  }

  .icon-background {
    margin-right: 5px;
    border-radius: 50px;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0; // évite que l’icône se compresse
  }
}
</style>
